import React from "react";
import {connect} from "react-redux";
import {recordCameraSettings, resetCameraSettings, setLastPhoto, setPhotos} from "@data/redux/actions/camera";
import {setCameraStatus} from "@data/redux/actions/activity";
import CameraComponent from "@common/camera/CameraComponent";


const CameraScreen = props => {
    return <CameraComponent {...props} />;
}

const mapStateToProps = state => {
    return {
        ratioSaved: state.camera?.ratio,
        imagePaddingSaved: state.camera?.imagePadding
    }
}

const mapDispatchToProps = {
    setNewPhoto: setLastPhoto,
    recordCameraSettings,
    resetCameraSettings,
    setPhotos,
    setCameraStatus
}

export default connect(mapStateToProps, mapDispatchToProps)(CameraScreen)